import React from 'react';

import withStyles from '@mui/styles/withStyles';
import MUITabs from '@mui/material/Tabs';

const Tabs = withStyles(theme => ({
  indicator: {
    backgroundColor: theme.palette.primary,
  },
}))(props => (
  <MUITabs {...props} textColor="primary" indicatorColor="primary" />
));

export default Tabs;
